

import React from 'react';
import { TrendingUp, Users, Server, Award } from 'lucide-react';

interface StatData {
  icon: React.ReactNode;
  number: string;
  label: string;
  description: string;
  color: string;
}

const Stats: React.FC = () => {
  const stats: StatData[] = [
    {
      icon: <TrendingUp className="w-8 h-8" />,
      number: '10,000+',
      label: '活跃用户',
      description: '来自全球的科研机构和企业用户',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: <Server className="w-8 h-8" />,
      number: '100,000+',
      label: '计算核心',
      description: '可随时调用的高性能计算资源',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: <Users className="w-8 h-8" />,
      number: '500+',
      label: '企业客户',
      description: '覆盖生物医药、汽车、材料等行业',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: <Award className="w-8 h-8" />,
      number: '99.9%',
      label: '服务可用性',
      description: '全年7x24小时稳定运行保障',
      color: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section className="spacing-responsive bg-gradient-to-br from-gray-50 to-white">
      <div className="container-responsive">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-responsive-lg font-bold text-gray-900 mb-4">
            数据说话，实力见证
          </h2>
          <p className="text-responsive-sm text-gray-600 max-w-3xl mx-auto">
            ChainCloud云超算平台服务全球用户，提供专业可靠的高性能计算服务
          </p>
        </div>

        {/* Stats Grid */}
        <div className="cards-grid-responsive">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-responsive card-responsive shadow-responsive hover:-translate-y-2 transition-all duration-500"
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${stat.color} opacity-0 group-hover:opacity-10 rounded-responsive transition-opacity duration-500`} />
              
              {/* Icon */}
              <div className={`icon-responsive-xl bg-gradient-to-br ${stat.color} rounded-responsive flex items-center justify-center text-white mb-6 lg:mb-8 group-hover:scale-110 transition-transform duration-300`}>
                {React.cloneElement(stat.icon as React.ReactElement, { 
                  className: "w-6 h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10" 
                })}
              </div>

              {/* Number */}
              <div className="text-responsive-lg font-bold text-gray-900 mb-2 lg:mb-3 group-hover:scale-105 transition-transform duration-300">
                {stat.number}
              </div>

              {/* Label */}
              <div className="text-responsive-md font-semibold text-gray-800 mb-3 lg:mb-4">
                {stat.label}
              </div>

              {/* Description */}
              <div className="text-responsive-xs text-gray-600 leading-relaxed">
                {stat.description}
              </div>

              {/* Decorative Element */}
              <div className={`absolute top-4 lg:top-6 right-4 lg:right-6 w-2 h-2 lg:w-3 lg:h-3 bg-gradient-to-br ${stat.color} rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-300`} />
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 sm:mt-16">
          <div className="inline-flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4 bg-white rounded-2xl sm:rounded-full px-6 sm:px-8 py-4 shadow-lg">
            <span className="text-gray-600 font-medium text-sm sm:text-base">立即加入我们的用户行列</span>
            <button className="bg-gradient-to-r from-primary-600 to-primary-700 text-white px-6 py-2 rounded-full font-medium hover:shadow-lg transition-all duration-300 hover:scale-105 text-sm sm:text-base">
              开始使用
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats; 